import { posthog } from "@/lib/posthog";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export function PostHogPageviews() {
  const location = useLocation();

  useEffect(() => {
    // Capture the standard PostHog pageview event for SPAs
    posthog.capture("$pageview", {
      $current_url: window.location.href,
    });
  }, [location]);

  return null;
}
